import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { StatusCount } from '@nimmsta/ng-workflow-lib/models';
import dayjs, { Dayjs } from 'dayjs';
import { Observable } from 'rxjs';
import {
  JobDashboardConfiguration,
  JobDashboardRange,
} from './job-dashboard-configuration';
import { environment } from '../../../../../environments/environment';
import {
  getFromForRange as getRangeFrom,
  getToForRange as getRangeTo,
} from './job-dashboard-range.utils';

@Injectable({
  providedIn: 'root',
})
export class JobDashboardService {
  protected http = inject(HttpClient);

  getData(config: JobDashboardConfiguration): Observable<StatusCount[]> {
    let from = config.from;
    let to = config.to;
    if (config.range !== JobDashboardRange.CUSTOM) {
      const now = dayjs();
      from = this.getFromForRange(config.range, now);
      to = this.getToForRange(config.range, now);
    }
    return this.http.post<StatusCount[]>(
      `${environment.apiUrls.workflow}/api/v1/dashboard/jobs/status-count`,
      {
        dataConnectionIds: config.dataConnectionIds,
        from,
        to,
      },
    );
  }

  getFromForRange(range: JobDashboardRange, referenceTime = dayjs()): Dayjs {
    return getRangeFrom(range, referenceTime);
  }

  getToForRange(range: JobDashboardRange, referenceTime = dayjs()): Dayjs {
    return getRangeTo(range, referenceTime);
  }
}
